module.exports = __webpack_public_path__ + "img/11456a49c69f240be01a860ba7008056.bfd7b114.png";